import {useState, useCallback} from "react";
import "./xlork.scss";

export function XlorkClient(props) {
	let {
		settings = {},
		licenseKey,
		user,
		loadOnDemand = null,
		origin = "https://app.xlork.com",
		children = null,
		onCancel = function (response) {
			console.log("[onCancelDefault]", response);
		},
		onComplete = function (response) {
			console.log("[onCompleteDefault]", response);
		},
	} = props;

	settings = Object.assign(
		{},
		{
			title: "Upload Data",
			allowInvalidSubmit: true,
			theme: null,
			maxRecords: 0,
			sampleUrl: null,
			columns: [],
			display: "popup",
			header: true,
			branding: false,
			history: false,
			social: true,
		},
		settings
	);

	const defaultChannel = "__xlork";
	const [initilize, setInitilize] = useState(0);
	const [loader, setLoader] = useState(true);
	const [embedURL, setEmbedURL] = useState(origin + "/embed/" + licenseKey);
	const [allowLoadIframe, setallowLoadIframe] = useState({
		error: true,
		message: "",
	});

	const validateClientConfig = useCallback(
		({settings, licenseKey, user, embedURL, onComplete, onCancel}) => {
			let _tmpError = "";
			if (!licenseKey) {
				_tmpError = "[REQUIRED] A Valid licenseKey is required.";
			} else if (!user) {
				_tmpError = `[REQUIRED] user not defined.`;
			} else if (!user?.email) {
				_tmpError = `[REQUIRED] email(unique) not defined.`;
			} else if (!embedURL) {
				_tmpError = `[REQUIRED] embedURL not defined.`;
			} else if (onComplete && typeof onComplete !== "function") {
				_tmpError = `[REQUIRED] onComplete should be function type.`;
			} else if (onCancel && typeof onCancel !== "function") {
				_tmpError = `[REQUIRED]  onCancel should be function type.`;
			} else if (!settings) {
				_tmpError = `[REQUIRED] setting not defined.`;
			} else if (!settings?.hasOwnProperty("columns")) {
				_tmpError = `[REQUIRED] should have required property 'columns'`;
			} else if (!settings?.columns?.length > 0) {
				//_tmpError = `[REQUIRED] should have atlest one column in  'columns'`;
			} else {
				settings?.columns?.forEach((s) => {
					if (!(s.label && s.key)) {
						_tmpError = `[REQUIRED] each column should have label & key in  'columns'`;
						return false;
					}
				});
			}
			return {error: _tmpError ? true : false, message: _tmpError};
		},
		[settings]
	);

	const recivedMessageFromIframe = useCallback(
		(event) => {
			const data = event?.data;
			if (typeof data == "object" && data?.channel == defaultChannel) {
				switch (data?.type) {
					case "[IFRAME LOADED]":
						setLoader(false);
						const eventData = {
							type: "[CONFIG INITILIZE]",
							channel: defaultChannel,
							settings,
							licenseKey,
							user,
						};
						window.frames["__xlork_iframe"].postMessage(eventData, "*");
						break;

					case "[onComplete]":
						onComplete && onComplete(data.value);
					case "[onCancel]":
						window.removeEventListener(
							"message",
							recivedMessageFromIframe,
							false
						);
						document?.body?.classList?.remove("__xlork_modal_open");
						data?.type == "[onCancel]" && onCancel && onCancel();
						setInitilize(0);
						break;
				}
			}
		},
		[settings]
	);

	const Loader = ({title = "Connecting xlork .."}) => {
		return (
			<>
				<div className={"__xlork_loader"}>
					<div className="loader_ripple">
						<div></div>
						<div></div>
					</div>
					<span> {title}</span>
				</div>
			</>
		);
	};

	const init = () => {
		const {error, message} = validateClientConfig({
			settings,
			licenseKey,
			user,
			embedURL,
			onComplete,
			onCancel,
		});
		if (!error) {
			window.addEventListener("message", recivedMessageFromIframe, false);
			setInitilize(1);
			setLoader(true);
			document?.body?.classList?.add("__xlork_modal_open");
		} else {
			setallowLoadIframe({error, message});
		}
	};

	return (
		<>
			{allowLoadIframe?.error && allowLoadIframe?.message ? (
				<span className="__xlork_error">*{allowLoadIframe?.message}</span>
			) : (
				<>
					{initilize == 1 && (
						<div
							className={`__xlork_iframe_container ${
								settings?.display == "inline" ? "_inline" : ""
							}`}
						>
							{loader && <Loader />}
							<iframe
								allowFullScreen
								name="__xlork_iframe"
								src={`${embedURL}`}
								onLoad={() => setLoader(false)}
								className={loader ? "__xlork_hidden" : ""}
								id="__xlork_iframe"
							></iframe>
						</div>
					)}

					{initilize == 0 &&
						(loadOnDemand ? (
							loadOnDemand(init)
						) : children ? (
							<div onClick={init}>{children}</div>
						) : (
							<button className="btn __xlork_btn_default" onClick={init}>
								Click to upload
							</button>
						))}
				</>
			)}
		</>
	);
}

// Also export as default for flexibility
export default XlorkClient;
